<!-- 定制申请 -->
<template>
	<div class="customized-apply">
		<HeaderTopView />
		<HeaderView />
		<NavView />
		<!--巨幕-->
		<div class="adv">
			<div class="word">
				<div class="top-title">{{ $t('nav.service') }}</div>
				<!-- <h3 class="se-title">定制服务</h3> -->
			</div>
		</div>
		<div class="content word">
			<h4>{{$t('nav.service')}}</h4>
			<div class="from-content">
				<div class="from-content-input">
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.productName" :placeholder="$t('customizedApply.productName')"
						 :class="fromInputStyle[0]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.indexRequirement" :placeholder="$t('customizedApply.indexRequirement')"
						 :class="fromInputStyle[1]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.sizeRequirement" :placeholder="$t('customizedApply.sizeRequirement')"
						 :class="fromInputStyle[2]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.demandQuantity" :placeholder="$t('customizedApply.demandQuantity')"
						 :class="fromInputStyle[3]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.deliveryCycle" :placeholder="$t('customizedApply.deliveryCycle')"
						 :class="fromInputStyle[4]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.qualityGrade" :placeholder="$t('customizedApply.qualityGrade')"
						 :class="fromInputStyle[5]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.weight" :placeholder="$t('customizedApply.weight')" :class="fromInputStyle[6]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.installationMode" :placeholder="$t('customizedApply.installationMode')"
						 :class="fromInputStyle[7]" />
					</label>
					<label>
						<span>*</span>
						<input type="text" maxlength="100" v-model="fromData.useEnvironment" :placeholder="$t('customizedApply.useEnvironment')"
						 :class="fromInputStyle[8]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.receivingAddress" :placeholder="$t('customizedApply.sendAddress')"
						 :class="fromInputStyle[9]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.receivingPhone " :placeholder="$t('customizedApply.contractStyle')"
						 :class="fromInputStyle[10]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.otherProcessRequirements" :placeholder="$t('customizedApply.otherProcessRequirements')"
						 :class="fromInputStyle[11]" />
					</label>
					<label><span>*</span>
						<input type="text" maxlength="100" v-model="fromData.receivingUser" :placeholder="$t('customizedApply.receivingUser')"
						 :class="fromInputStyle[12]" />
					</label>
				</div>
				<label class="detail"><span>*</span>
					<textarea maxlength="2000" v-model="fromData.detailedDescription" rows="8" :placeholder="$t('customizedApply.detailedDescription')"
					 :class="fromInputStyle[13]"></textarea>
				</label>
				<div class="file-input">
					<div class="file-input-bg" @click="selectFile">{{!!file.name ? file.name : $t('customizedApply.annexFile')}}
					</div>
					<span class="rm-file" :style="(!!file.name ? 'display:block;' : 'display:none;')" @click="rmFile">{{$t('customizedApply.remove')}}</span>
					<input id="annex" type="file" @change="fileChange($event)" multiple="multiplt" class="add-file-right-input" />
				</div>
			</div>
			<div class="confirm-apply-btn" @click="submitClickFn">{{$t('customizedApply.confirmApply')}}</div>
		</div>
		<Footer />
		<LoginPop v-if="popShow" @closePop="closePopFn" />
	</div>
</template>

<script>
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import HeaderView from "@/components/assembly/Header.vue"; //头部模块
	import NavView from "@/components/assembly/Nav.vue"; //导航模块
	import Footer from "@/components/assembly/Footer.vue"; //导航模块
	import {
		fileUpload
	} from '../../assets/js/request1'; //文件上传
	import {
		Loading,
		Message
	} from 'element-ui';
	import LoginPop from "@/components/assembly/LoginPop.vue"; //登录弹窗

	export default {
		name: "apply.vue",
		components: {
			HeaderTopView,
			NavView,
			Footer,
			HeaderView,
			LoginPop
		},
		data() {
			return {
				popShow: false,
				timer: null, //定时器
				file: {},
				token: '',
				fromInputStyle: [],
				isSubmit: false, //防抖
				fromData: {
					productName: '',
					indexRequirement: '',
					sizeRequirement: '',
					demandQuantity: '',
					deliveryCycle: '',
					qualityGrade: '',
					weight: '',
					installationMode: '',
					useEnvironment: '',
					receivingAddress: '',
					receivingPhone: '',
					otherProcessRequirements: '',
					receivingUser: '',
					detailedDescription: ''
				}
			};
		},
		created() {
			this.token = sessionStorage.getItem('token');
		},
		methods: {
			closePopFn(i) {
				this.popShow = !i;
			},
			submitClickFn() {
				// this.$confirm('您确认提交数据吗？', '提示', {
				this.$confirm(this.$t('customizedApply.confirmSubmit'), this.$t('customizedApply.title'), {
					confirmButtonText: this.$t('publicText.sure'),
					cancelButtonText: this.$t('publicText.cancel'),
					type: 'primary'
				}).then(() => {
					this.submitData();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('publicText.cancel') + this.$t('publicText.submit')
					});
				});
			},
			submitData() { //提交数据方法
				//提交数据的时候先校验数据，（有文件的时候上传文件，再提交数据）
				if (!this.token) {
					this.popShow = true;
					return;
				}
				if (!this.checkData() || this.isSubmit) return;
				this.isSubmit = true; //正在提交
				//提交数据的局部方法
				let submit = (annexFile = '') => {
					let loading = Loading.service({
						lock: true,
						background: 'rgba(0, 0, 0, 0)',
						text: this.$t('customizedApply.submitting'),
					});
					this.$post('api/customized/order/apply', { ...this.fromData,
						annexFile,
						token: this.token
					}).then(res => {
						loading.close();
						this.isSubmit = false;
						if (res.code === 0) {
							this.cleanAllData();
							//确认消息点击事件触发
							this.$alert(this.$t('customizedApply.alertText'), this.$t('customizedApply.title'), {
								confirmButtonText: this.$t('publicText.sure'),
								callback: action => {
									
								}
							});
							return;
						}
						Message({
							message: this.$t('customizedApply.submiterr'),
							type: 'error',
							duration: 2000
						});
					});
				};

				if (!!this.file.name) {
					//如果有文件的话先上传文件
					let loading = Loading.service({
						lock: true,
						background: 'rgba(0, 0, 0, 0)',
						text: this.$t('customizedApply.uploadFile'),
					});
					let formData = new FormData();
					formData.append('file', this.file);
					formData.append('token', sessionStorage.getItem('token'));
					fileUpload({
						url: '/open/upload/file',
						data: formData
					}).then(res => {
						//文件上传成功后提交其他数据
						loading.close();
						if (res.code === 0) return submit(res.data);
						this.isSubmit = false;
						Message({
							message: this.$t('customizedApply.uploadFileError'),
							type: 'error',
							duration: 2000
						});
					});
					return;
				}
				//没有附件就直接上传
				submit();
			},
			checkData() { //校验数据并提示
				if (!!this.timer) clearTimeout(this.timer);
				let waitCheck = this.fromData;
				let checkFlag = true;
				let keys = Object.keys(waitCheck);
				let styles = new Array(keys.length);
				keys.forEach((key, index) => {
					let flag = !waitCheck[key].trim();
					if (checkFlag && flag) checkFlag = false;
					if (flag) styles[index] = 'input-f00-border';
				});
				this.fromInputStyle = styles;
				if (!checkFlag) {
					this.timer = setTimeout(() => {
						console.log(this.fromInputStyle);
						this.fromInputStyle = new Array(this.fromInputStyle.length);
						this.timer = null;
					}, 1500);
				}
				return checkFlag;
			},
			cleanAllData() { //清空所有数据
				let fromData = JSON.parse(JSON.stringify(this.fromData));
				Object.keys(fromData).forEach(key => fromData[key] = '');
				this.fromData = fromData;
				this.file = {};
			},
			selectFile() { //选择文件触发
				document.getElementById('annex').click();
			},
			fileChange(e) { //选择文件的时候触发change事件
				this.file = e.target.files[0];
			},
			//清除文件
			rmFile() {
				this.file = {}
			}
		}
	}
</script>

<style scoped>
	span{
		margin-right: 5px;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	    -webkit-appearance: none;
	    appearance: none; 
	    margin: 0; 
	}
	.adv {
		width: 100%;
		height: 300px;
		background: url("../../assets/images/bg6.png") center center no-repeat;
		background-size: cover;
		padding-top: 77px;
	}

	.top-title {
		font-size: 40px;
		color: #fff;
		text-align: center;
	}

	.se-title {
		font-size: 30px;
		color: #fff;
		text-align: center;
		margin-top: 19px;
	}

	/*内容表单*/
	.content>h4 {
		text-align: center;
		display: inline-block;
		border-image: url(../../assets/images/center_line.png) 50 0 round;
		-webkit-border-image: url(../../assets/images/center_line.png) 50 0 round;
		border-width: 5px;
		border-style: solid;
		border-top: none;
		border-right: none;
		border-left: none;
		padding: 5px 0;
		font-size: 24px;
		margin: 40px auto;
	}

	.from-content>.from-content-input {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.from-content>.from-content-input>label,
	.from-content>.detail {
		display: flex;
		line-height: 40px;
		color: #f00;
	}

	.from-content>.from-content-input>label>input {
		width: 300px;
		height: 40px;
		border: 1px solid #D3D3D3;
		margin: 10px auto;
		padding: 2px 10px;
	}

	.from-content>.detail>textarea {
		width: 100%;
		padding: 10px;
		resize: none;
		margin: 10px auto 20px auto;
	}

	.input-f00-border {
		/*红色边框*/
		border-color: #f00 !important;
		box-shadow: 0 0 3px #f00;
	}

	/*文件选择器*/
	.file-input {
		display: flex;
	}

	.file-input>input {
		display: none;
	}

	.file-input>.file-input-bg {
		display: inline-block;
		cursor: pointer;
		background: url(../../assets/images/upload_annex.png) no-repeat;
		height: 40px;
		text-indent: 45px;
		text-align: left;
		font-size: 18px;
		color: #969696;
		line-height: 40px;
	}

	.confirm-apply-btn {
		background: #0090FF;
		color: #FFFFFF;
		font-size: 18px;
		text-align: center;
		width: max-content;
		padding: 15px 50px;
		margin: 20px 0 70px 0;
	}

	.rm-file {
		color: #999;
		height: 1em;
	}

	.rm-file:hover {
		color: #f00;
	}
</style>



// WEBPACK FOOTER //
// src/components/customized/Apply.vue